module.exports = React.addons.CSSTransitionGroup;